import { Component } from '@angular/core';

@Component({
    moduleId: module.id,
    templateUrl: "manageComputers.component.html"
})
export class ManageComputersComponent {}
